// Mirrors Stream::ChatPrompt.language_family (LAN-1644): "spanish (european)"
// and "Latin American Spanish" are both Spanish, and Mandarin is Chinese.
// Keep in sync with app/models/stream/chat_prompt.rb#language_family; the
// cases in test/javascript/contents/same_language_test.js match the Ruby ones.
export function languageFamily(name) {
  const family = String(name || '').toLowerCase().trim().replace(/\s*\(.*\)$/, '').split(/\s+/).pop();
  return family === 'mandarin' ? 'chinese' : family;
}

export function nativeMatchesTarget(nativeLanguage, targetLanguage) {
  if (!nativeLanguage || !targetLanguage) return false;

  return languageFamily(nativeLanguage) === languageFamily(targetLanguage);
}

// Points to Learning Settings, shown where a translation would only repeat the
// text because the native language is the language being learned. Only the
// action ("update your native language") is the link.
export function sameLanguageNoteHtml(settingsUrl = document.querySelector('meta[name="langua_settings_url"]')?.content) {
  const action = I18n.t('javascript.chat_modals.translator.same_language_link');
  const link = settingsUrl ? `<a href="${settingsUrl}" data-turbolinks="false">${action}</a>` : action;

  return `<p class="small text-muted mt-2 mb-0">${I18n.t('javascript.chat_modals.translator.same_language_note_html', { link })}</p>`;
}
